import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    render() {
        return <section>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/people/cover@2x.jpg)"}}>
                <div className="scroll-down-wrapper">
                    <div className="scroll-down">
                        <p>Scroll<br/>down</p>
                        <img src="public/images/scroll.svg" alt=""/>
                    </div>
                </div>
            </div>

            <div className="section-wrapper">
                <div className="container">
                    <div className="row row-align-middle">
                        <div className="gr-6"
                             style={{
                                 position: "relative",
                                 zIndex: 3,
                                 marginTop: "-0vw"
                             }}>
                            <img src="public/images/people/20150305-JMK_2174-Edit.jpg" alt=""
                                 className="image-resp"/>
                        </div>
                        <div className="gr-6">
                            <div className="padding-dynamic-left-3 padding-dynamic-top-3">
                                <h1>PEOPLE<br/>PHOTO<br/>GRAPHY</h1>
                                <div className="width-percent-97">
                                    <p>
                                        Ein gutes Portrait zeigt die Individualität und den Charakter einer Person. Es
                                        hält das eigentliche Wesen bildlich fest. Hingegen ist es in Modefotografie die
                                        Aufgabe des Fotografen eine Person visuell zu erschaffen die dem Produkt dient.
                                        <br/><br/>Ein gutes Portrait hinterlässt Eindruck, gerade in ihrem Business.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="section-wrapper" style={{paddingTop: 0}}>
                <div style={{padding: "0vw 10vw"}}>
                    <div className="image text-center" style={{marginTop: "0vw", position: "relative", zIndex: 2}}>
                        <img src="public/images/people/collage_2_1@2x.jpg" alt="" className="image-resp"
                             style={{width: "70vw"}}/>
                    </div>


                    <div className="row">
                        <div className="gr-6"
                             style={{position: "relative", zIndex: 0, transform: "translate(0px, 5vw)"}}>
                            <div className="image transform-r-0">
                                <div className="animate" data-transform-y="-5%" data-transform-duration="300%">
                                    <img src="public/images/people/collage_2_2@2x.jpg" alt="" className="image-resp"/>
                                </div>
                            </div>
                        </div>

                        <div className="gr-6">
                            <div className="image transform-l-0">
                                <div className="animate" data-transform-y="5%" data-transform-duration="100%">
                                    <img src="public/images/people/collage_2_3@2x.jpg" alt=""
                                         style={{width: "92%", float: "right", transform: "translate(0px, -5vw)"}}/>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/people/full_1@2x.jpg)"}}></div>

            <div className="section-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="gr-6 text-right">
                            <h1 style={{
                                fontSize: "4.5vw",
                                lineHeight: "4.6vw",
                                marginTop: "-2vw",
                                marginBottom: "2vw",
                                marginRight: "2vw"
                            }}>LETS TALK<br/>BUSINESS</h1>
                        </div>
                        <div className="gr-6 relative">
                            <div className="image absolute" style={{top: 0}}>
                                <img src="public/images/people/collage_3_2@2x.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="gr-1">&nbsp;</div>
                        <div className="gr-6 relative">
                            <div className="image">
                                <div className="animate" data-transform-y="5%" data-transform-duration="100%">
                                    <img src="public/images/people/collage_3_1@2x.jpg" alt="" className="image-resp"/>
                                </div>
                            </div>
                        </div>
                        <div className="gr-5"></div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image"
                 style={{backgroundImage: "url(public/images/people/20140218-JMK_0898.jpg)"}}></div>

            <div className="section-wrapper" style={{paddingBottom: "23vw"}}>
                <div className="row">
                    <div className="gr-5 no-gutter">
                        <div className="image">
                            <div className="animate" data-transform-y="-13%" data-transform-duration="100%">
                                <img src="public/images/people/collage_4_1@2x.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>
                    <div className="gr-2 no-gutter relative" style={{zIndex: 2}}>
                        <div className="image" style={{transform: "scale(2.2) translate(0px, 9vw)"}}>
                            <img src="public/images/people/collage_4_2@2x.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-5 no-gutter">
                        <div className="image" style={{transform: "translate(0px, 23vw)"}}>
                            <div className="animate" data-transform-y="13%" data-transform-duration="100%">
                                <img src="public/images/people/collage_4_3@2x.jpg" alt="" className="image-resp"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="section-wrapper">
                <div className="row">
                    <div className="gr-4 no-gutter" style={{transform: "translate(0px, 10vw)"}}>
                        <div className="image">
                            <img src="public/images/people/collage_5_1@2x.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-4 no-gutter">
                        <div className="image"
                             style={{transform: "scale(1.1) translate(0px, 18vw)", paddingBottom: "18vw"}}>
                            <img src="public/images/people/collage_5_2@2x.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-4 no-gutter">
                        <div className="image">
                            <img src="public/images/people/collage_5_3@2x.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/people/moma.jpg)"}}></div>


            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/categories/lookbook">
                            <h1>NEXT</h1>
                        </a>
                    </div>
                </div>
            </div>

        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/people.jsx